export default "__VITE_ASSET__BRey7qGH__"